<template>
  <div>
    <el-dropdown @command="handleCommand">
      <div class="set-color">
        <span class=" el-color-picker__color color-option " :style="{ 'background-color': theme }">
        </span>
      </div>

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="item in colorList" :command="item.val" :key="item.val" class="color-inner">
          <div :style="{ 'background-color': item.val }" class="color-option"> </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>

export default {
  data() {
    return {
      colorList: [],
      theme: '#409eff',

    }
  },
  props: {
    data: {
      type: Object
    }
  },
  mounted() {
    const { val, listEntrie } = this.data
    const { val: themeColor, } = val
    this.theme = themeColor;
    this.colorList = listEntrie.map(i => ({ id: i.id, val: i.name }));

  },
  methods: {
    handleCommand(val) {
      console.log(val);
      document.getElementById('app').style.setProperty('--themeColor', val)
      document.documentElement.style.setProperty('el-button--primary', val)
      window.sessionStorage.setItem('theme', val)
      this.theme = val
      this.$emit('setColor', val)
    }
  }
}

</script>


<style scoped lang="scss">
// .color-block {
//   width: 100%;

//   height: 32px;
//   padding: 6px;
//   border-radius: 4px;
//   border: 1px solid #e6e6e6;
//   box-sizing: border-box;

//   .color-inner {
//     width: 100%;
//     height: 100%;
//     border-radius: 3px;
//     background: var(--themeColor);
//     cursor: pointer;
//   }
// }

// .color-item {
//   width: 100%;
//   height: 28px;
//   // background: #88458c;
//   border-radius: 3px;
//   margin: 6px;
//   cursor: pointer;
// }


.demonstration {
  color: var(--themeColor--);
  font-size: 12px;
  // color: #409eff;
}

.set-color {
  display: inline-block;
  box-sizing: border-box;
  height: 32px;
  width: 32px;
  padding: 6px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  font-size: 0;
  position: relative;
  cursor: pointer;
  margin-right: 10px;
  background-color: #fff;
}

.color-option {
  display: inline-block;
  box-sizing: border-box;
  height: 18px;
  width: 18px;
  padding: 4px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  font-size: 0;
  position: relative;
  cursor: pointer;
}

.color-inner {
  // width: 100%;
  background-color: var(--themeColor--);
}
</style>